import EditModal from "./EditTable";
import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import DynamicTable from "../Widgets/Global/DynamicTable";
import TabMenu from "./TabMenu";
import { useDispatch } from "react-redux";
import { updateCompanyData } from "../../features/CompanySlice";
import AddModal from "../Dynamics/AddModal";
import { EyeIcon, PaperClipIcon, CalendarIcon, UserIcon, CheckCircleIcon, ChatBubbleLeftRightIcon, XMarkIcon } from "@heroicons/react/24/solid";
import toast, { Toaster } from 'react-hot-toast';
import { fetchAllContacts, pb, generateContactPassword } from "../../api/pocketbase";
const BRAND_GREEN = "#90c740";

const DetailsPage = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  pb.autoCancellation(false);
  const [customerData, setCustomerData] = useState(null);
  const [serverDetails, setServerDetails] = useState(null);
  const [superUsers, setSuperUsers] = useState([]);
  const [administrators, setAdministrators] = useState([]);
  const [technicals, setTechnicals] = useState([]);
  const [allContacts, setAllContacts] = useState([]);
  const [availableContacts, setAvailableContacts] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [ticketConversations, setTicketConversations] = useState({});
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [addTicketModal, setAddTicketModal] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [isImageViewerOpen, setIsImageViewerOpen] = useState(false);
  const [viewerImages, setViewerImages] = useState([]);
  const [viewerIndex, setViewerIndex] = useState(0);
  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
  const [openTicketsPage, setOpenTicketsPage] = useState(1);
  const [closedTicketsPage, setClosedTicketsPage] = useState(1);
  const [isAddingUpdate, setIsAddingUpdate] = useState(false);
  const [newUpdateText, setNewUpdateText] = useState("");
  const [processingTickets, setProcessingTickets] = useState(new Set());
  const [isSubmittingUpdate, setIsSubmittingUpdate] = useState(false);
  const [addModalData, setAddModalData] = useState(null);
  const [dockerImages, setDockerImages] = useState([]);
  const [dockerImageModal, setDockerImageModal] = useState(null);
  const [isPemUpdating, setIsPemUpdating] = useState(false);
  const pemInputRef = useRef(null);
  const ticketsPerPage = 4;

  // Get current user from localStorage
  useEffect(() => {
    try {
      const PB_AUTH = JSON.parse(localStorage.getItem("pocketbase_auth") || "null");
      if (PB_AUTH && PB_AUTH.record) {
        setCurrentUser(PB_AUTH.record);
      }
    } catch (error) {
      console.error("Error reading auth session:", error);
    }
  }, []);

  const fetchData = async (collection, filter , expand = "") => {
    try {
      console.log(12345, collection , filter , expand);
      let finalResponse;
      let apiResponse =  await pb.collection(collection).getFullList({ filter , expand });
      console.log(123456, apiResponse , collection, filter, expand);
      if(collection.includes("Tickets")) console.log("res>>" , apiResponse);
      
      // Handle all Contacts queries consistently
      if(collection === "Contacts") {
        console.log(`Fetching Contacts with filter: ${filter}`, apiResponse);
        console.log(`Contacts API response:`, apiResponse);
        
        // If filter includes AccessRight, return detailed structure for specific sections
        if(filter && filter.includes("AccessRight")) {
          finalResponse = apiResponse.map(({ Name, Surname, email, MobileNumber, AccessRight, SystemKnowledge, CanAccessPortal, id  }) => ({
            Name, Surname, email, MobileNumber, AccessRight, SystemKnowledge, CanAccessPortal, id
          }));
        } else {
          // For all Contacts (Authorized Personnel table), return structure with name, accessLevel, agreement
          finalResponse = apiResponse.map(({ Name, Surname, SystemKnowledge, CanAccessPortal, AccessRight, id }) => {
            return {
              name : `${Name || ""} ${Surname || ""}`.trim(),
              accessLevel : SystemKnowledge,
              agreement : CanAccessPortal,
              action : "",
              AccessRight : AccessRight,
              id
            }
          });
        }
        console.log(`Contacts final response:`, finalResponse);
        return finalResponse;
      }else if(collection==="Customers") {
        finalResponse = apiResponse.map((record) => {
          return {
            id: record.id,
            legalName : record.CommercialName,
            businessName : record.CompanyName,
            address : record.CompanyAddress,
            telephone1 : record.Telephone1,
            email : "-",
            url : "-",
            invoiceAddress : record.InvoiceAddress,
            legalBN : record.LegalBN,
            expanded: record.expand
          }
        })
        console.log("final response  for company details " , finalResponse);
        return finalResponse;
      }
      else if(collection.includes("Tickets")) {
        // First, separate main tickets and conversations
        const mainTickets = apiResponse.filter(ticket => !ticket.reference);
        const conversations = apiResponse.filter(ticket => ticket.reference);

        // Process main tickets
        const processedMainTickets = mainTickets.map((ticket) => {
          const {id, created, Communication, updated, reference, expand, Screenshot, Title, Read, TicketClose, Initiator} = ticket;
          return {
            id,
            created,
            Title: Title || "No Title",
            Communication,
            updated,
            reference,
            Read: !!Read,
            TicketClose: TicketClose || null,
            Initiator: Initiator || "",
            SupportMember: `${expand?.SupportMember?.Name || ""} ${expand?.SupportMember?.Surname || ""}`.trim(),
            SupportMemberId: expand?.SupportMember?.id,
            hasAttachments: Screenshot && Screenshot.length > 0,
            attachments: Screenshot ? Screenshot.map(file => `https://dbap.a-traq.com/api/files/Tickets/${id}/${file}`) : [],
            conversationCount: conversations.filter(conv => conv.reference === id).length
          };
        });

        // Sort tickets: open tickets first (oldest to newest), then closed tickets (oldest to newest)
        const sortedTickets = processedMainTickets.sort((a, b) => {
          const aIsClosed = !!a.TicketClose;
          const bIsClosed = !!b.TicketClose;
          
          // If one is closed and the other isn't, open tickets come first
          if (aIsClosed !== bIsClosed) {
            return aIsClosed ? 1 : -1;
          }
          
          // If both are open or both are closed, sort by creation date (oldest first)
          return new Date(a.created) - new Date(b.created);
        });

        // Process conversations and group them by main ticket ID
        const conversationsByTicket = conversations.reduce((acc, conv) => {
          if (!acc[conv.reference]) {
            acc[conv.reference] = [];
          }
          acc[conv.reference].push({
            id: conv.id,
            created: conv.created,
            updated: conv.updated,
            Communication: conv.Communication,
            Initiator: conv.Initiator || "",
            hasAttachments: conv.Screenshot && conv.Screenshot.length > 0,
            attachments: conv.Screenshot ? conv.Screenshot.map(file => `https://dbap.a-traq.com/api/files/Tickets/${conv.id}/${file}`) : []
          });
          return acc;
        }, {});

        // Sort conversations by updated timestamp (ascending)
        Object.keys(conversationsByTicket).forEach(ticketId => {
          conversationsByTicket[ticketId].sort((a, b) => new Date(a.updated) - new Date(b.updated));
        });

        setTicketConversations(conversationsByTicket);
        return sortedTickets;
      }
      else{
        // Handle other collections (not Contacts, Customers, or Tickets)
        // This is a fallback for any other collection types
        finalResponse = apiResponse;
        return finalResponse;
      }
    } catch (error) {
      console.error(`Error fetching data from ${collection}:`, error);
      console.error(`Filter used: ${filter}`);
      console.error(`Error details:`, error.response?.data || error.message);
      return [];
    }
  };

  
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setIsLoading(true);
        console.log("id before fetchAllData" , id);
        // Get current user's company ID
        let userCompanyId = id;
        try {
          const PB_AUTH = JSON.parse(localStorage.getItem("pocketbase_auth") || "null");
          userCompanyId = PB_AUTH?.record?.CompanyID || id;
        } catch (error) {
          console.error("Error reading auth session:", error);
        }
        
        console.log("Fetching data for company ID:", id);
        console.log("User company ID:", userCompanyId);
        
        // Helper to format expanded contact data
        const formatExpandedContact = (contact) => {
          if (!contact) return [];
          const contacts = Array.isArray(contact) ? contact : [contact];
          return contacts.map(c => ({
            Name: c.Name,
            Surname: c.Surname,
            email: c.email,
            MobileNumber: c.MobileNumber,
            AccessRight: c.AccessRight,
            id: c.id
          }));
        };

        const [customer, contactsList, ticketList, systemContacts] = await Promise.all([
          fetchData("Customers", `id="${id}"`, "SuperAdmin,Administrator,ARCChief"),
          // fetchData("Contacts", `CompanyID.id="${id}" && AccessRight="SuperUser"`),
          // fetchData("Contacts", `CompanyID.id="${id}" && AccessRight="Administrator"`),
          // fetchData("Contacts", `CompanyID.id="${id}" && AccessRight="Technical"`),
          fetchData("Contacts", `CompanyID ?= "${id}"`),
          fetchData("Tickets" , `CompanyID="${id}"` , "SupportMember"),
          fetchAllContacts()
        ]);
        
        console.log("Fetched data results:");
        console.log("Customer:", customer);
        // console.log("SuperUsers:", superUserList);
        // console.log("Administrators:", adminList);
        // console.log("Technicals:", technicalList);
        console.log("All Contacts:", contactsList);
        console.log("Tickets:", ticketList);
        console.log("System Contacts:", systemContacts);
        
        setCustomerData(customer);
        
        // Set lists from expanded customer data
        if (customer && customer.length > 0 && customer[0].expanded) {
          setSuperUsers(formatExpandedContact(customer[0].expanded.SuperAdmin));
          setAdministrators(formatExpandedContact(customer[0].expanded.Administrator));
          setTechnicals(formatExpandedContact(customer[0].expanded.ARCChief));
        } else {
          setSuperUsers([]);
          setAdministrators([]);
          setTechnicals([]);
        }

        setAllContacts(contactsList);
        setTickets(ticketList);
        setAvailableContacts(systemContacts);
        
        // Fetch Docker images from customer record
        try {
          console.log("id>>" , id);
          const customerRecord = await pb.collection("Server_Details").getFirstListItem(`customerId="${id}"`);
          console.log("customerRecord>>" , customerRecord);
          const images = customerRecord.images || [];
          console.log("images>>" , images); 
          setDockerImages(Array.isArray(images) ? images : []);
          setServerDetails(customerRecord);
        } catch (error) {
          console.error("Error fetching docker images / server details:", error);
          setDockerImages([]);
          setServerDetails(null);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllData();
  }, [id]); // Re-run when id changes

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#90c740] mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading customer details...</p>
        </div>
      </div>
    );
  }

  if (!customerData) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600">Customer not found</p>
        </div>
      </div>
    );
  }

  // **Table Sections (Left - 60%)**
  const tableSections = [
    { title: "Master User Details", data: superUsers || [] },
    { title: "Main Administrator Details", data: administrators || [] },
    { title: "ARC Chief Details", data: technicals || [] },
    { title: "Company Details", data: customerData || []},
  ];

  // **Related Customers Table (Right - 40%)**
  const allContactsColumns = [
    { key: "name", label: "Name" },
    { key: "accessLevel", label: "Access Level" },
    { key: "agreement", label: "Agreement" , type: "checkBox"},
    { key: "action", label: "Action" },
  ];

  const customerColumns = [
    {
      key : "Name" , label : "Name" , type : "info"   
    },
    {
      key : "Surname" , label : "Surname" , type : "info"   
    },
    {
      key : "email" , label : "Email" , type : "info"   
    },
    {
      key : "MobileNumber" , label : "Mobile Number" , type : "info"   
    },
  ];

  const companyDetailsColumns = [
    {
      key : "legalName" , label : "Legal Name of the company", type : "info"
    },
    {
      key : "businessName" , label : "Business name"
    },
    {
      key : "address" , label : "Address of Company"
    },
    {
      key : "telephone1" , label : "Main telephone of Company"
    },
    {
      key : "email" , label : "Generic Email of Company"
    },
    {
      key : "url" , label : "URL of Company:"
    },
    {
      key : "invoiceAddress" , label : "Invoice Address of Company"
    },
    {
      key : "legalBN" , label : "Legal Business number for invoice"
    },
  ]

  const handleSaveModalData = async (updatedData) => {
    try {
      console.log("method for updating data", updatedData);
      
      if (modalData.title === "Company Details") {
        // Handle Company Details - map display fields back to database fields
        const companyData = updatedData[0]; // Company Details is a single object array
        if (companyData && companyData.id) {
          // Helper function to clean values (convert "-" to empty string, handle null/undefined)
          const cleanValue = (value) => {
            if (value === "-" || value === null || value === undefined) return "";
            return String(value).trim();
          };
          
          const dbData = {
            CommercialName: cleanValue(companyData.legalName) || cleanValue(companyData.CommercialName),
            CompanyName: cleanValue(companyData.businessName) || cleanValue(companyData.CompanyName),
            CompanyAddress: cleanValue(companyData.address) || cleanValue(companyData.CompanyAddress),
            Telephone1: cleanValue(companyData.telephone1) || cleanValue(companyData.Telephone1),
            InvoiceAddress: cleanValue(companyData.invoiceAddress) || cleanValue(companyData.InvoiceAddress),
            LegalBN: cleanValue(companyData.legalBN) || cleanValue(companyData.LegalBN)
          };
          
          await pb.collection("Customers").update(companyData.id, dbData);
          
          // Refresh company data
          const updatedCompany = await fetchData("Customers", `id="${id}"`, "SuperAdmin,Administrator,ARCChief");
          setCustomerData(updatedCompany);
        }
      } else {
        // Updated logic for refreshing data after edit
        const formatExpandedContact = (contact) => {
            if (!contact) return [];
            const contacts = Array.isArray(contact) ? contact : [contact];
            return contacts.map(c => ({
              Name: c.Name,
              Surname: c.Surname,
              email: c.email,
              MobileNumber: c.MobileNumber,
              AccessRight: c.AccessRight,
              id: c.id
            }));
        };

      // Handle Contacts Updates (standard property updates)
      for (const user of updatedData) {
          if (user.id) {
            const contactData = {};
            if (user.Name !== undefined) contactData.Name = user.Name;
            if (user.Surname !== undefined) contactData.Surname = user.Surname;
            if (user.email !== undefined) contactData.email = user.email;
            if (user.MobileNumber !== undefined) contactData.MobileNumber = user.MobileNumber;
             // ... other fields
            
            if (Object.keys(contactData).length > 0) {
              await pb.collection("Contacts").update(user.id, contactData);
            }
          }
        }
        
        // Refresh specific section or all
        // We now primarily refresh the Customer record to get updated relations
        const updatedCustomer = await fetchData("Customers", `id="${id}"`, "SuperAdmin,Administrator,ARCChief");
        setCustomerData(updatedCustomer);
        
        if (updatedCustomer && updatedCustomer.length > 0 && updatedCustomer[0].expanded) {
             setSuperUsers(formatExpandedContact(updatedCustomer[0].expanded.SuperAdmin));
             setAdministrators(formatExpandedContact(updatedCustomer[0].expanded.Administrator));
             setTechnicals(formatExpandedContact(updatedCustomer[0].expanded.ARCChief));
        }

        if (modalData.title === "Authorized Personnel") {
          const allContactsList = await fetchData("Contacts", `CompanyID ?= "${id}"`);
          setAllContacts(allContactsList);
        } else {
           // If we updated a role contact, they might also be in the All list
           const updatedContacts = await fetchData("Contacts", `CompanyID ?= "${id}"`);
           setAllContacts(updatedContacts);
        }
      }

      // Refresh Redux store (this ensures the global state updates)
      dispatch(updateCompanyData({ companyId: id }));
      console.log("Data updated successfully!");
      toast.success('Data updated successfully!');
    } catch (error) {
      console.error("Error updating data:", error);
      toast.error('Failed to update data. Please try again.');
    }
  };

      const refreshRoleContacts = async () => {
        const formatExpandedContact = (contact) => {
            if (!contact) return [];
            const contacts = Array.isArray(contact) ? contact : [contact];
            return contacts.map(c => ({
              Name: c.Name,
              Surname: c.Surname,
              email: c.email,
              MobileNumber: c.MobileNumber,
              AccessRight: c.AccessRight,
              id: c.id
            }));
        };

        const updatedCustomer = await fetchData("Customers", `id="${id}"`, "SuperAdmin,Administrator,ARCChief");
        setCustomerData(updatedCustomer);
        
        if (updatedCustomer && updatedCustomer.length > 0 && updatedCustomer[0].expanded) {
             setSuperUsers(formatExpandedContact(updatedCustomer[0].expanded.SuperAdmin));
             setAdministrators(formatExpandedContact(updatedCustomer[0].expanded.Administrator));
             setTechnicals(formatExpandedContact(updatedCustomer[0].expanded.ARCChief));
        }

        const updatedContacts = await fetchData("Contacts", `CompanyID ?= "${id}"`);
        setAllContacts(updatedContacts);
      };

  // Handle adding new data
  const handleAddNewData = async (newData) => {
    try {
      setIsLoading(true);
      
      // Default password for new contacts
      const DEFAULT_PASSWORD = generateContactPassword();
      
      // Use sectionTitle to determine which section we're adding to
      const sectionTitle = addModalData?.sectionTitle || addModalData?.title;

      const linkContactToRole = async (contactId, targetField) => {
        await pb.collection("Customers").update(id, {
          [`${targetField}+`]: contactId
        });
        await pb.collection("Contacts").update(contactId, {
          "CompanyID+": id
        });
      };

      // Handle Adding Existing User
      if (newData.existingUserId) {
        console.log(`Mapping existing user ${newData.existingUserId} to company ${id}`);
        
        let targetField = "";
        
        if (sectionTitle === "Master User Details" || addModalData?.title === "Add Master User") {
            targetField = "SuperAdmin";
        } else if (sectionTitle === "Main Administrator Details" || addModalData?.title === "Add Main Administrator") {
            targetField = "Administrator";
        } else if (sectionTitle === "ARC Chief Details" || addModalData?.title === "Add ARC Chief") {
            targetField = "ARCChief";
        } 
        
        if (targetField) {
            await linkContactToRole(newData.existingUserId, targetField);
            toast.success('Existing user linked to company successfully!');
        } else {
            console.warn("Could not determine target field for existing user");
             if (sectionTitle === "Authorized Personnel" || addModalData?.title === "Add Authorized Personnel") {
                  toast('Cannot add existing user to Authorized Personnel without changing their company.', { icon: '⚠️' } );
             }
        }

        await refreshRoleContacts();
        dispatch(updateCompanyData({ companyId: id }));
        return;
      }
      
      if (sectionTitle === "Master User Details" || addModalData?.title === "Add Master User") {
        toast(`A password (${DEFAULT_PASSWORD}) was set for this user. Share it with them and ask them to change it after first login.`, {
          duration: 8000,
        });
        
        const contactData = {
          Name: newData.Name || "",
          Surname: newData.Surname || "",
          email: newData.email || "",
          MobileNumber: newData.MobileNumber || "",
          password: DEFAULT_PASSWORD,
          passwordConfirm: DEFAULT_PASSWORD,
          emailVisibility: true,
          CompanyID: [id],
          AccessRight: "SuperUser"
        };
        
        const created = await pb.collection("Contacts").create(contactData);
        await pb.collection("Customers").update(id, { "SuperAdmin+": created.id });
        toast.success('Master User added successfully!');
      } else if (sectionTitle === "Main Administrator Details" || addModalData?.title === "Add Main Administrator") {
        toast(`A password (${DEFAULT_PASSWORD}) was set for this user. Share it with them and ask them to change it after first login.`, {
          duration: 8000,
        });
        
        const contactData = {
          Name: newData.Name || "",
          Surname: newData.Surname || "",
          email: newData.email || "",
          MobileNumber: newData.MobileNumber || "",
          password: DEFAULT_PASSWORD,
          passwordConfirm: DEFAULT_PASSWORD,
          emailVisibility: true,
          CompanyID: [id],
          AccessRight: "Administrator"
        };
        
        const created = await pb.collection("Contacts").create(contactData);
        await pb.collection("Customers").update(id, { "Administrator+": created.id });
        toast.success('Main Administrator added successfully!');
      } else if (sectionTitle === "ARC Chief Details" || addModalData?.title === "Add ARC Chief") {
        toast(`A password (${DEFAULT_PASSWORD}) was set for this user. Share it with them and ask them to change it after first login.`, {
          duration: 8000,
        });
        
        const contactData = {
          Name: newData.Name || "",
          Surname: newData.Surname || "",
          email: newData.email || "",
          MobileNumber: newData.MobileNumber || "",
          password: DEFAULT_PASSWORD,
          passwordConfirm: DEFAULT_PASSWORD,
          emailVisibility: true,
          CompanyID: [id],
          AccessRight: "Technical"
        };
        
        const created = await pb.collection("Contacts").create(contactData);
        await pb.collection("Customers").update(id, { "ARCChief+": created.id });
        toast.success('ARC Chief added successfully!');
      } else if (sectionTitle === "Company Details" || addModalData?.title === "Update Company Details") {
        const companyData = {
          CommercialName: newData.legalName || "",
          CompanyName: newData.businessName || "",
          CompanyAddress: newData.address || "",
          Telephone1: newData.telephone1 || "",
          InvoiceAddress: newData.invoiceAddress || "",
          LegalBN: newData.legalBN || ""
        };
        
        await pb.collection("Customers").update(id, companyData);
        const updatedCompany = await fetchData("Customers", `id="${id}"`, "SuperAdmin,Administrator,ARCChief");
        setCustomerData(updatedCompany);
        toast.success('Company details updated successfully!');
      } else if (addModalData?.title === "Add Authorized Personnel") {
        toast(`A password (${DEFAULT_PASSWORD}) was set for this user. Share it with them and ask them to change it after first login.`, {
          duration: 8000,
        });
        
        const contactData = {
          Name: newData.Name || "",
          Surname: newData.Surname || "",
          email: newData.email || "",
          MobileNumber: newData.MobileNumber || "",
          password: DEFAULT_PASSWORD,
          passwordConfirm: DEFAULT_PASSWORD,
          emailVisibility: true,
          CompanyID: [id],
          AccessRight: newData.AccessRight || ""
        };
        
        const created = await pb.collection("Contacts").create(contactData);
        if (newData.AccessRight === "SuperUser") {
          await pb.collection("Customers").update(id, { "SuperAdmin+": created.id });
        } else if (newData.AccessRight === "Administrator") {
          await pb.collection("Customers").update(id, { "Administrator+": created.id });
        } else if (newData.AccessRight === "Technical") {
          await pb.collection("Customers").update(id, { "ARCChief+": created.id });
        }
        
        toast.success('Authorized Personnel added successfully!');
      } else {
        console.error("Unknown section title:", sectionTitle, addModalData);
        toast.error('Unknown section. Please try again.');
        return;
      }

      dispatch(updateCompanyData({ companyId: id }));
      await refreshRoleContacts();
    } catch (error) {
      console.error("Error adding new data:", error);
      
      // Extract error message from PocketBase error
      let errorMessage = 'Failed to add data. Please try again.';
      if (error?.response?.data) {
        const errorData = error.response.data;
        if (errorData.message) {
          errorMessage = errorData.message;
        } else if (typeof errorData === 'object') {
          const errorFields = Object.keys(errorData);
          if (errorFields.length > 0) {
            const firstError = errorData[errorFields[0]];
            errorMessage = `${errorFields[0]}: ${firstError?.message || firstError}`;
          }
        }
      } else if (error?.message) {
        errorMessage = error.message;
      }
      
      toast.error(errorMessage);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  // Get add modal configuration for each section
  const getAddModalConfig = (sectionTitle) => {
    const baseContactFields = [
      { key: "Name", label: "Name", type: "text", required: true },
      { key: "Surname", label: "Surname", type: "text", required: true },
      { key: "email", label: "Email", type: "text", required: true },
      { key: "MobileNumber", label: "Mobile Number", type: "text" }
    ];

    if (sectionTitle === "Master User Details") {
      return {
        title: "Add Master User",
        fields: baseContactFields
      };
    } else if (sectionTitle === "Main Administrator Details") {
      return {
        title: "Add Main Administrator",
        fields: baseContactFields
      };
    } else if (sectionTitle === "ARC Chief Details") {
      return {
        title: "Add ARC Chief",
        fields: baseContactFields
      };
    } else if (sectionTitle === "Company Details") {
      return {
        title: "Update Company Details",
        fields: [
          { key: "legalName", label: "Legal Name of the company", type: "text", required: true },
          { key: "businessName", label: "Business name", type: "text", required: true },
          { key: "address", label: "Address of Company", type: "text", required: true },
          { key: "telephone1", label: "Main telephone of Company", type: "text" },
          { key: "email", label: "Generic Email of Company", type: "text" },
          { key: "url", label: "URL of Company", type: "text" },
          { key: "invoiceAddress", label: "Invoice Address of Company", type: "text" },
          { key: "legalBN", label: "Legal Business number for invoice", type: "text" }
        ]
      };
    }
    return null;
  };

  // Handle Docker Images
  const handleSaveDockerImages = async (updatedImages) => {
    try {
      console.log("updatedImages>>" , updatedImages);
      // Try different field names to find where docker images are stored
      const customerRecord = await pb.collection("Server_Details").getFirstListItem(`customerId="${id}"`);
      // const fieldName = customerRecord.ServerInfo !== undefined ? "ServerInfo" :
      //                  customerRecord.DockerImages !== undefined ? "DockerImages" :
      //                  customerRecord.Images !== undefined ? "Images" :
      //                  customerRecord.serverInfo !== undefined ? "serverInfo" :
      //                  customerRecord.dockerImages !== undefined ? "dockerImages" : "ServerInfo";
      console.log("customerRecord.id>>" , customerRecord.id);
      const updatedRecord = await pb.collection("Server_Details").update(customerRecord.id, {
        images: updatedImages
      });
      
      setDockerImages(updatedRecord.images || updatedImages);
      setServerDetails(updatedRecord);
      toast.success('Docker images updated successfully!');
    } catch (error) {
      console.error("Error saving docker images:", error);
      toast.error('Failed to save docker images. Please try again.');
      throw error;
    }
  };

  const handleAddDockerImage = async (newImage) => {
    try {
      const updatedImages = [...dockerImages, newImage];
      await handleSaveDockerImages(updatedImages);
      toast.success('Docker image added successfully!');
    } catch (error) {
      console.error("Error adding docker image:", error);
    }
  };

  const handleEditDockerImage = async (index, updatedImage) => {
    try {
      const updatedImages = [...dockerImages];
      updatedImages[index] = updatedImage;
      await handleSaveDockerImages(updatedImages);
      toast.success('Docker image updated successfully!');
    } catch (error) {
      console.error("Error updating docker image:", error);
    }
  };

  const handleDeleteDockerImage = async (index) => {
    try {
      const updatedImages = dockerImages.filter((_, i) => i !== index);
      await handleSaveDockerImages(updatedImages);
      toast.success('Docker image deleted successfully!');
    } catch (error) {
      console.error("Error deleting docker image:", error);
    }
  };

  // PEM file management (Server_Details collection)
  const getPemFileName = () => {
    if (!serverDetails) return null;
    console.log("serverDetails.pemFile>>" , serverDetails);
    // PocketBase file fields are usually arrays
    if (Array.isArray(serverDetails.pem) && serverDetails.pem.length > 0) {
      return serverDetails.pem[0];
    }
    if (typeof serverDetails.pem === "string" && serverDetails.pem) {
      return serverDetails.pem;
    }
    return null;
  };

  const getPemFileUrl = () => {
    const fileName = getPemFileName();
    if (!serverDetails || !fileName) return null;
    return `https://dbap.a-traq.com/api/files/Server_Details/${serverDetails.id}/${fileName}`;
  };

  const handleUploadPemFile = async (file) => {
    if (!serverDetails) {
      toast.error("Server details not found for this customer.");
      return;
    }
    try {
      setIsPemUpdating(true);
      const formData = new FormData();
      formData.append("pem", file);
      const updatedRecord = await pb.collection("Server_Details").update(serverDetails.id, formData);
      setServerDetails(updatedRecord);
      toast.success("PEM file updated successfully!");
    } catch (error) {
      console.error("Error uploading PEM file:", error);
      toast.error("Failed to upload PEM file. Please try again.");
    } finally {
      setIsPemUpdating(false);
    }
  };

  const handleDeletePemFile = async () => {
    if (!serverDetails) {
      toast.error("Server details not found for this customer.");
      return;
    }
    try {
      setIsPemUpdating(true);
      const updatedRecord = await pb.collection("Server_Details").update(serverDetails.id, {
        pem: null,
      });
      setServerDetails(updatedRecord);
      toast.success("PEM file removed successfully!");
    } catch (error) {
      console.error("Error deleting PEM file:", error);
      toast.error("Failed to delete PEM file. Please try again.");
    } finally {
      setIsPemUpdating(false);
    }
  };

  const addTicketData =  {
    title: "New Ticket",
    data: [],
    collection: "Tickets",
    fields: [
      { key: "Title", label: "Title", type: "text" },
      { key: "Initiator", label: "Initiator", type: "list" , data: allContacts },
      { key: "Communication", label: "Description", type: "paragraph" },
      { key: "Screenshot", label: "Screenshot", type: "file" },
      { key: "SupportMember", label: "Support Member", type: "list" , data: allContacts  },
    ]
  }

  const handleSaveNewData = async (data) => {
    data.CompanyID = id;
    function toFormData(o) {
      return Object.entries(o).reduce((d,e) => (d.append(...e),d), new FormData())
    }
    const finalFormData = toFormData(data);
    
    try {
      const createData = await pb.collection("Tickets").create(finalFormData);
      toast.success('Ticket created successfully!');
      const updatedTickets = await fetchData("Tickets", `CompanyID="${id}"`, "SupportMember");
      setTickets(updatedTickets);
    } catch (error) {
      toast.error('Failed to create ticket. Please try again.');
      throw error;
    }
  }

  // Image viewer helpers
  const openImageViewer = (images, startIndex = 0) => {
    setViewerImages(images || []);
    setViewerIndex(startIndex);
    setIsImageViewerOpen(true);
  };
  const closeImageViewer = () => setIsImageViewerOpen(false);
  const nextImage = () => setViewerIndex((prev) => (prev + 1) % viewerImages.length);
  const prevImage = () => setViewerIndex((prev) => (prev - 1 + viewerImages.length) % viewerImages.length);

  // Parse HTML content
  const parseHtmlContent = (htmlContent) => {
    if (!htmlContent) return '';
    // Create a temporary div to parse HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  // Open ticket modal
  const openTicketModal = (ticket) => {
    setSelectedTicket(ticket);
    setIsTicketModalOpen(true);
  };

  // Close ticket modal
  const closeTicketModal = () => {
    setIsTicketModalOpen(false);
    setSelectedTicket(null);
    setIsAddingUpdate(false);
    setNewUpdateText("");
  };

  // Skeleton loading components
  const TicketCardSkeleton = () => (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm animate-pulse">
      <div className="p-4 sm:p-6">
        <div className="flex justify-between items-start mb-3">
          <div className="flex-1 min-w-0">
            <div className="h-5 bg-gray-200 rounded mb-2"></div>
          </div>
          <div className="flex items-center gap-2 flex-shrink-0">
            <div className="h-6 w-16 bg-gray-200 rounded"></div>
          </div>
        </div>
        <div className="space-y-2 mb-3">
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <div className="h-4 w-20 bg-gray-200 rounded"></div>
          <div className="h-4 w-16 bg-gray-200 rounded"></div>
          <div className="h-4 w-12 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  );

  const TicketModalSkeleton = () => (
    <div className="space-y-6 max-h-[80vh] overflow-y-auto animate-pulse">
      <div className="flex justify-between items-start border-b border-gray-200 pb-4">
        <div className="flex-1">
          <div className="h-6 bg-gray-200 rounded mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-1/3"></div>
        </div>
      </div>
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl border border-gray-200">
        <div className="flex justify-between items-center mb-4">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
            <div>
              <div className="h-4 bg-gray-200 rounded w-24 mb-1"></div>
              <div className="h-3 bg-gray-200 rounded w-32"></div>
            </div>
          </div>
        </div>
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-5/6"></div>
          <div className="h-4 bg-gray-200 rounded w-4/6"></div>
        </div>
      </div>
    </div>
  );

  // Update database operations with loading states
  const handleMarkAsResolved = async (ticketId) => {
    try {
      setProcessingTickets(prev => new Set([...prev, ticketId]));
      const currentDate = new Date().toISOString();
      await pb.collection("Tickets").update(ticketId, {
        TicketClose: currentDate
      });
      
      // Update local state
      setTickets(prevTickets => 
        prevTickets.map(ticket => 
          ticket.id === ticketId 
            ? { ...ticket, TicketClose: currentDate }
            : ticket
        )
      );
      
      // Update selected ticket if it's the same
      if (selectedTicket && selectedTicket.id === ticketId) {
        setSelectedTicket(prev => ({ ...prev, TicketClose: currentDate }));
      }
      
      toast.success('Ticket marked as resolved successfully!');
    } catch (error) {
      console.error('Error marking ticket as resolved:', error);
      toast.error('Failed to mark ticket as resolved. Please try again.');
    } finally {
      setProcessingTickets(prev => {
        const newSet = new Set(prev);
        newSet.delete(ticketId);
        return newSet;
      });
    }
  };

  const handleReopenTicket = async (ticketId) => {
    try {
      setProcessingTickets(prev => new Set([...prev, ticketId]));
      await pb.collection("Tickets").update(ticketId, {
        TicketClose: null
      });
      
      // Update local state
      setTickets(prevTickets => 
        prevTickets.map(ticket => 
          ticket.id === ticketId 
            ? { ...ticket, TicketClose: null }
            : ticket
        )
      );
      
      // Update selected ticket if it's the same
      if (selectedTicket && selectedTicket.id === ticketId) {
        setSelectedTicket(prev => ({ ...prev, TicketClose: null }));
      }
      
      toast.success('Ticket reopened successfully!');
    } catch (error) {
      console.error('Error reopening ticket:', error);
      toast.error('Failed to reopen ticket. Please try again.');
    } finally {
      setProcessingTickets(prev => {
        const newSet = new Set(prev);
        newSet.delete(ticketId);
        return newSet;
      });
    }
  };

  const handleAddUpdate = async () => {
    if (!newUpdateText.trim() || !selectedTicket) return;
    
    try {
      setIsSubmittingUpdate(true);
      const updateData = {
        Title: `Update to: ${selectedTicket.Title}`,
        Communication: newUpdateText,
        reference: selectedTicket.id,
        CompanyID: id,
        Initiator: currentUser ? `${currentUser.Name || ""} ${currentUser.Surname || ""}`.trim() : "",
        SupportMember: selectedTicket.SupportMemberId || null
      };

      await pb.collection("Tickets").create(updateData);
      
      const updatedTickets = await fetchData("Tickets", `CompanyID="${id}"`, "SupportMember");
      setTickets(updatedTickets);
      
      // The conversations will be automatically updated by the fetchData function
      // which processes and sets the ticketConversations state
      
      // Clear form
      setNewUpdateText("");
      setIsAddingUpdate(false);
      
      toast.success('Update added successfully!');
    } catch (error) {
      console.error('Error adding update:', error);
      toast.error('Failed to add update. Please try again.');
    } finally {
      setIsSubmittingUpdate(false);
    }
  };

  // Render ticket card
  const renderTicketCard = (ticket) => {
    const isClosed = !!ticket.TicketClose;
    const isAssigned = !!ticket.SupportMemberId;
    const isProcessing = processingTickets.has(ticket.id);

  return (
    <div 
        key={ticket.id}
        className={`bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition-all duration-200 relative ${
          isClosed ? 'opacity-75 bg-gray-50' : 'cursor-pointer hover:border-[#90c740]/30'
        } ${!ticket.Read && !isClosed ? 'border-l-4 border-l-[#90c740]' : ''} ${isClosed ? 'border-l-4 border-l-red-500' : ''} ${
          isProcessing ? 'opacity-50 pointer-events-none' : ''
        }`}
        onClick={() => !isProcessing && openTicketModal(ticket)}
      >
        {isProcessing && (
          <div className="absolute inset-0 bg-white/80 rounded-xl flex items-center justify-center z-10">
            <div className="flex items-center gap-2 text-[#90c740]">
              <svg className="animate-spin h-5 w-5" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span className="text-sm font-medium">Processing...</span>
            </div>
          </div>
        )}
        <div className="p-4 sm:p-6">
          <div className="flex justify-between items-start mb-3">
            <div className="flex-1 min-w-0">
              <h3 className="text-base sm:text-lg font-semibold text-gray-900 truncate">{ticket.Title}</h3>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              {ticket.hasAttachments && (
                <button
                  onClick={(e) => { e.stopPropagation(); openImageViewer(ticket.attachments, 0); }}
                  className="inline-flex items-center gap-1 px-2 py-1 bg-blue-50 text-blue-700 rounded-lg hover:bg-blue-100 transition-colors text-xs font-medium"
                  title="View attachments"
                >
                  <PaperClipIcon className="h-3 w-3" />
                  <span className="hidden sm:inline">{ticket.attachments.length}</span>
                </button>
              )}
              {isClosed && (
                <span className="inline-flex items-center px-2 py-1 rounded-lg text-xs font-medium bg-red-100 text-red-700">
                  <CheckCircleIcon className="h-3 w-3 mr-1" />
                  <span className="hidden sm:inline">Closed</span>
                </span>
              )}
              {!ticket.Read && !isClosed && (
                <span className="inline-flex items-center px-2 py-1 rounded-lg text-xs font-medium bg-blue-100 text-blue-700">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mr-1"></span>
                  <span className="hidden sm:inline">New</span>
                </span>
              )}
            </div>
          </div>
          <p className="text-gray-600 text-sm line-clamp-2 mb-3">
            {parseHtmlContent(ticket.Communication)}
          </p>
          <div className="flex flex-wrap items-center gap-2 text-xs sm:text-sm">
            <div className="flex items-center gap-1 text-gray-500">
              <UserIcon className="h-3 w-3 sm:h-4 sm:w-4 text-gray-400" />
              <span className="font-medium truncate">{ticket.Initiator || '—'}</span>
            </div>
            <div className="flex items-center gap-1 text-gray-500">
              <CalendarIcon className="h-3 w-3 sm:h-4 sm:w-4 text-gray-400" />
              <span>{new Date(ticket.created).toLocaleDateString()}</span>
            </div>
            {ticket.conversationCount > 0 && (
              <div className="flex items-center gap-1 text-gray-500">
                <ChatBubbleLeftRightIcon className="h-3 w-3 sm:h-4 sm:w-4 text-gray-400" />
                <span className="font-medium">{ticket.conversationCount}</span>
              </div>
            )}
            {isAssigned ? (
              <span className="inline-flex items-center px-2 py-1 rounded-lg text-xs font-medium bg-green-100 text-green-700">
                <UserIcon className="h-3 w-3 mr-1" />
                <span className="truncate">{ticket.SupportMember}</span>
              </span>
            ) : (
              <span className="inline-flex items-center px-2 py-1 rounded-lg text-xs font-medium bg-yellow-100 text-yellow-700">
                <UserIcon className="h-3 w-3 mr-1" />
                <span className="hidden sm:inline">Unassigned</span>
              </span>
            )}
          </div>
          
          {/* Action Buttons */}
          <div className="flex justify-end gap-2 mt-4 pt-4 border-t border-gray-100">
            {!isClosed ? (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleMarkAsResolved(ticket.id);
                }}
                disabled={isProcessing}
                className="inline-flex items-center gap-1 px-3 py-2 bg-[#90c740] text-white rounded-lg hover:bg-[#7ebd2e] transition-colors text-xs font-medium shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isProcessing ? (
                  <svg className="animate-spin h-3 w-3" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                ) : (
                  <CheckCircleIcon className="h-3 w-3" />
                )}
                {isProcessing ? 'Processing...' : 'Mark as Resolved'}
              </button>
            ) : (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleReopenTicket(ticket.id);
                }}
                disabled={isProcessing}
                className="inline-flex items-center gap-1 px-3 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors text-xs font-medium shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isProcessing ? (
                  <svg className="animate-spin h-3 w-3" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                ) : (
                  <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                  </svg>
                )}
                {isProcessing ? 'Processing...' : 'Reopen'}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  // Render ticket list
  const renderTicketList = () => {
    if (isLoading) {
      return (
        <div className="space-y-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {[...Array(4)].map((_, index) => (
              <TicketCardSkeleton key={index} />
            ))}
          </div>
        </div>
      );
    }

    if (tickets.length === 0) {
      return (
        <div className="text-center py-12">
          <div className="text-gray-400 mb-6">
            <svg className="mx-auto h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-900 mb-2">No tickets found</h3>
          <p className="text-gray-500 mb-6">Get started by creating a new support ticket.</p>
          <button
            onClick={() => setAddTicketModal(addTicketData)}
            className="inline-flex items-center px-4 py-2 bg-[#90c740] text-white rounded-lg hover:bg-[#7ebd2e] transition-colors duration-200 font-medium"
          >
            Create First Ticket
          </button>
        </div>
      );
    }

    // Separate open and closed tickets
    const openTickets = tickets.filter(ticket => !ticket.TicketClose);
    const closedTickets = tickets.filter(ticket => !!ticket.TicketClose);

    // Calculate pagination for open tickets
    const openTicketsStartIndex = (openTicketsPage - 1) * ticketsPerPage;
    const openTicketsEndIndex = openTicketsStartIndex + ticketsPerPage;
    const openTicketsToShow = openTickets.slice(openTicketsStartIndex, openTicketsEndIndex);
    const openTicketsTotalPages = Math.ceil(openTickets.length / ticketsPerPage);

    // Calculate pagination for closed tickets
    const closedTicketsStartIndex = (closedTicketsPage - 1) * ticketsPerPage;
    const closedTicketsEndIndex = closedTicketsStartIndex + ticketsPerPage;
    const closedTicketsToShow = closedTickets.slice(closedTicketsStartIndex, closedTicketsEndIndex);
    const closedTicketsTotalPages = Math.ceil(closedTickets.length / ticketsPerPage);

    // Pagination component
    const Pagination = ({ currentPage, totalPages, onPageChange, sectionName }) => {
      if (totalPages <= 1) return null;

      const pages = [];
      const maxVisiblePages = 5;
      let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
      let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      const isClosedSection = sectionName === "Closed Tickets";
      const activeColor = isClosedSection ? "bg-gray-600" : "bg-[#90c740]";

      return (
        <div className="flex items-center justify-center gap-2 mt-6">
          <button
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-3 py-2 rounded-lg font-medium transition-colors ${
              currentPage === 1
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            Previous
          </button>
          
          {startPage > 1 && (
            <>
              <button
                onClick={() => onPageChange(1)}
                className="px-3 py-2 rounded-lg font-medium bg-gray-200 text-gray-700 hover:bg-gray-300 transition-colors"
              >
                1
              </button>
              {startPage > 2 && (
                <span className="px-2 text-gray-400">...</span>
              )}
            </>
          )}

          {pages.map(page => (
            <button
              key={page}
              onClick={() => onPageChange(page)}
              className={`px-3 py-2 rounded-lg font-medium transition-colors ${
                page === currentPage
                  ? `${activeColor} text-white`
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              {page}
            </button>
          ))}

          {endPage < totalPages && (
            <>
              {endPage < totalPages - 1 && (
                <span className="px-2 text-gray-400">...</span>
              )}
              <button
                onClick={() => onPageChange(totalPages)}
                className="px-3 py-2 rounded-lg font-medium bg-gray-200 text-gray-700 hover:bg-gray-300 transition-colors"
              >
                {totalPages}
              </button>
            </>
          )}

          <button
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`px-3 py-2 rounded-lg font-medium transition-colors ${
              currentPage === totalPages
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
            }`}
          >
            Next
          </button>
        </div>
      );
    };

    return (
      <div className="space-y-8">
        {/* Open Tickets */}
        {openTickets.length > 0 && (
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <div className="w-3 h-3 bg-[#90c740] rounded-full"></div>
              Open Tickets ({openTickets.length})
            </h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {openTicketsToShow.map(renderTicketCard)}
            </div>
            {openTicketsTotalPages > 1 && (
              <Pagination
                currentPage={openTicketsPage}
                totalPages={openTicketsTotalPages}
                onPageChange={setOpenTicketsPage}
                sectionName="Open Tickets"
              />
            )}
          </div>
        )}

        {/* Closed Tickets */}
        {closedTickets.length > 0 && (
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <div className="w-3 h-3 bg-gray-400 rounded-full"></div>
              Closed Tickets ({closedTickets.length})
            </h3>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {closedTicketsToShow.map(renderTicketCard)}
            </div>
            {closedTicketsTotalPages > 1 && (
              <Pagination
                currentPage={closedTicketsPage}
                totalPages={closedTicketsTotalPages}
                onPageChange={setClosedTicketsPage}
                sectionName="Closed Tickets"
              />
            )}
          </div>
        )}
      </div>
    );
  };

  // Render ticket modal content
  const renderTicketModalContent = () => {
    if (!selectedTicket) return <TicketModalSkeleton />;

    const conversations = ticketConversations[selectedTicket.id] || [];
    const isClosed = !!selectedTicket.TicketClose;

    return (
      <div className="space-y-6 max-h-[80vh] overflow-y-auto">
        {/* Ticket Header */}
        <div className="flex justify-between items-start border-b border-gray-200 pb-4">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <h3 className="text-xl font-bold text-gray-900">{selectedTicket.Title}</h3>
              {isClosed && (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-red-100 text-red-700">
                  <CheckCircleIcon className="h-4 w-4 mr-1.5" />
                  Closed
                </span>
              )}
              {!selectedTicket.Read && (
                <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-700">
                  <span className="w-2 h-2 bg-blue-600 rounded-full mr-1.5"></span>
                  New
                </span>
              )}
            </div>
            <p className="text-sm text-gray-500">Ticket ID: {selectedTicket.id}</p>
          </div>
        </div>

        {/* Main Ticket Content */}
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 p-6 rounded-xl border border-gray-200">
          <div className="flex justify-between items-center mb-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-[#90c740] rounded-full flex items-center justify-center">
                <UserIcon className="h-4 w-4 text-white" />
              </div>
              <div>
                <span className="text-sm font-medium text-gray-900">{selectedTicket.Initiator}</span>
                <div className="flex items-center gap-2 text-xs text-gray-500">
                  <CalendarIcon className="h-3 w-3" />
                  <span>{new Date(selectedTicket.created).toLocaleDateString()} at {new Date(selectedTicket.created).toLocaleTimeString()}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="prose max-w-none">
            <div 
              className="text-gray-800 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: selectedTicket.Communication }}
            />
          </div>
          {selectedTicket.hasAttachments && (
            <div className="mt-6 pt-4 border-t border-gray-200">
              <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <PaperClipIcon className="h-4 w-4" />
                Attachments ({selectedTicket.attachments.length})
              </h4>
              <div className="flex gap-3 flex-wrap">
                {selectedTicket.attachments.map((url, index) => (
                  <button
                    key={index}
                    onClick={() => openImageViewer(selectedTicket.attachments, index)}
                    className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-50 hover:border-[#90c740] transition-colors duration-200 shadow-sm"
                  >
                    <PaperClipIcon className="h-4 w-4" />
                    Attachment {index + 1}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Add Update Section - Only for open tickets */}
        {!isClosed && (
          <div className="bg-white border border-gray-200 rounded-xl p-6">
            <div className="flex items-center justify-between mb-4">
              <h4 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                <ChatBubbleLeftRightIcon className="h-5 w-5 text-[#90c740]" />
                Add Update
              </h4>
              <button
                onClick={() => setIsAddingUpdate(!isAddingUpdate)}
                disabled={isSubmittingUpdate}
                className="inline-flex items-center gap-2 px-4 py-2 bg-[#90c740] text-white rounded-lg hover:bg-[#7ebd2e] transition-colors duration-200 font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isAddingUpdate ? (
                  <>
                    <XMarkIcon className="h-4 w-4" />
                    Cancel
                  </>
                ) : (
                  <>
                    <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                    Add Update
                  </>
                )}
              </button>
            </div>
            
            {isAddingUpdate && (
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Update Message
                  </label>
                  <textarea
                    value={newUpdateText}
                    onChange={(e) => setNewUpdateText(e.target.value)}
                    rows={4}
                    disabled={isSubmittingUpdate}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#90c740] focus:border-[#90c740] transition-colors duration-200 placeholder-gray-400 resize-none disabled:opacity-50 disabled:cursor-not-allowed"
                    placeholder={isSubmittingUpdate ? "Submitting update..." : "Enter your update message..."}
                  />
                </div>
                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => {
                      setIsAddingUpdate(false);
                      setNewUpdateText("");
                    }}
                    disabled={isSubmittingUpdate}
                    className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleAddUpdate}
                    disabled={!newUpdateText.trim() || isSubmittingUpdate}
                    className="px-4 py-2 bg-[#90c740] text-white rounded-lg hover:bg-[#7ebd2e] transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                  >
                    {isSubmittingUpdate ? (
                      <>
                        <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Adding Update...
                      </>
                    ) : (
                      'Add Update'
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Conversations */}
        {conversations.length > 0 && (
          <div className="space-y-4">
            <div className="flex items-center gap-3 border-b border-gray-200 pb-3">
              <ChatBubbleLeftRightIcon className="h-5 w-5 text-[#90c740]" />
              <h4 className="text-lg font-semibold text-gray-900">
                Conversations ({conversations.length})
              </h4>
            </div>
            <div className="space-y-4">
              {conversations.map((conv, index) => (
                <div key={conv.id} className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                  <div className="flex justify-between items-center mb-4">
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 bg-gray-500 rounded-full flex items-center justify-center">
                        <UserIcon className="h-4 w-4 text-white" />
                      </div>
                      <div>
                        <span className="text-sm font-medium text-gray-900">{conv.Initiator}</span>
                        <div className="flex items-center gap-2 text-xs text-gray-500">
                          <CalendarIcon className="h-3 w-3" />
                          <span>{new Date(conv.updated).toLocaleDateString()} at {new Date(conv.updated).toLocaleTimeString()}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="prose max-w-none">
                    <div 
                      className="text-gray-800 leading-relaxed"
                      dangerouslySetInnerHTML={{ __html: conv.Communication }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  // Docker Image Modal Component
  const DockerImageModal = ({ mode, image, index, onSave, onClose }) => {
    const [formData, setFormData] = useState({
      name: image?.name || "",
      imageFull: image?.imageFull || "",
      imageRepository: image?.imageRepository || "",
      imageTag: image?.imageTag || "",
      subDomain: image?.subDomain || "",
      ports: image?.ports || [{ hostPort: "", containerPort: "", protocol: "tcp" }],
      environment: image?.environment || [{ key: "", value: "", isSecret: false }],
      metadata: image?.metadata || {}
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const modalRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
          onClose();
        }
      };
      const handleEscape = (event) => {
        if (event.key === "Escape") {
          onClose();
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEscape);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("keydown", handleEscape);
      };
    }, [onClose]);

    const handleChange = (field, value) => {
      setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handlePortChange = (index, field, value) => {
      const newPorts = [...formData.ports];
      newPorts[index] = { ...newPorts[index], [field]: value };
      setFormData(prev => ({ ...prev, ports: newPorts }));
    };

    const handleEnvChange = (index, field, value) => {
      const newEnv = [...formData.environment];
      newEnv[index] = { ...newEnv[index], [field]: value };
      setFormData(prev => ({ ...prev, environment: newEnv }));
    };

    const addPort = () => {
      setFormData(prev => ({
        ...prev,
        ports: [...prev.ports, { hostPort: "", containerPort: "", protocol: "tcp" }]
      }));
    };

    const removePort = (index) => {
      setFormData(prev => ({
        ...prev,
        ports: prev.ports.filter((_, i) => i !== index)
      }));
    };

    const addEnvironment = () => {
      setFormData(prev => ({
        ...prev,
        environment: [...prev.environment, { key: "", value: "", isSecret: false }]
      }));
    };

    const removeEnvironment = (index) => {
      setFormData(prev => ({
        ...prev,
        environment: prev.environment.filter((_, i) => i !== index)
      }));
    };

    const handleSubmit = async () => {
      setIsSubmitting(true);
      try {
        // Clean up empty ports and environment variables
        const cleanedPorts = formData.ports.filter(p => p.hostPort && p.containerPort);
        const cleanedEnv = formData.environment.filter(e => e.key && e.value);
        
        const imageData = {
          name: formData.name,
          imageFull: formData.imageFull,
          imageRepository: formData.imageRepository,
          imageTag: formData.imageTag,
          subDomain: formData.subDomain || undefined,
          ports: cleanedPorts,
          environment: cleanedEnv,
          metadata: formData.metadata
        };
        
        await onSave(imageData);
      } catch (error) {
        console.error('Error saving docker image:', error);
      } finally {
        setIsSubmitting(false);
      }
    };

    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
        <div
          ref={modalRef}
          className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col"
        >
          <div className="flex-none flex justify-between items-center p-6 border-b border-gray-200">
            <div>
              <h2 className="text-xl font-bold text-gray-900">
                {mode === 'add' ? 'Add Docker Image' : 'Edit Docker Image'}
              </h2>
              <p className="text-sm text-gray-500 mt-1">Configure Docker image details</p>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors p-2 rounded-lg hover:bg-gray-100"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
          </div>

          <div className="flex-1 p-6 overflow-y-auto min-h-0">
            <div className="space-y-6">
              {/* Basic Information */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) => handleChange("name", e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#90c740] focus:border-[#90c740] transition-colors"
                    placeholder="e.g., ui"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Image Full <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={formData.imageFull}
                    onChange={(e) => handleChange("imageFull", e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#90c740] focus:border-[#90c740] transition-colors"
                    placeholder="e.g., comonprofessionals/atraq2:latest"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Image Repository
                  </label>
                  <input
                    type="text"
                    value={formData.imageRepository}
                    onChange={(e) => handleChange("imageRepository", e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#90c740] focus:border-[#90c740] transition-colors"
                    placeholder="e.g., comonprofessionals/atraq2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Image Tag
                  </label>
                  <input
                    type="text"
                    value={formData.imageTag}
                    onChange={(e) => handleChange("imageTag", e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#90c740] focus:border-[#90c740] transition-colors"
                    placeholder="e.g., latest"
                  />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Subdomain
                  </label>
                  <input
                    type="text"
                    value={formData.subDomain}
                    onChange={(e) => handleChange("subDomain", e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#90c740] focus:border-[#90c740] transition-colors"
                    placeholder="e.g., customer1 (for customer1.example.com)"
                  />
                </div>
              </div>

              {/* Ports */}
              <div>
                <div className="flex justify-between items-center mb-4">
                  <label className="block text-sm font-medium text-gray-700">Ports</label>
                  <button
                    type="button"
                    onClick={addPort}
                    className="text-sm text-[#90c740] hover:text-[#7ebd2e] font-medium"
                  >
                    + Add Port
                  </button>
                </div>
                <div className="space-y-3">
                  {formData.ports.map((port, index) => (
                    <div key={index} className="flex gap-3 items-end">
                      <div className="flex-1">
                        <label className="block text-xs font-medium text-gray-600 mb-1">Host Port</label>
                        <input
                          type="number"
                          value={port.hostPort}
                          onChange={(e) => handlePortChange(index, "hostPort", e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#90c740] focus:border-[#90c740]"
                          placeholder="3000"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block text-xs font-medium text-gray-600 mb-1">Container Port</label>
                        <input
                          type="number"
                          value={port.containerPort}
                          onChange={(e) => handlePortChange(index, "containerPort", e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#90c740] focus:border-[#90c740]"
                          placeholder="3000"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block text-xs font-medium text-gray-600 mb-1">Protocol</label>
                        <select
                          value={port.protocol}
                          onChange={(e) => handlePortChange(index, "protocol", e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#90c740] focus:border-[#90c740]"
                        >
                          <option value="tcp">TCP</option>
                          <option value="udp">UDP</option>
                        </select>
                      </div>
                      {formData.ports.length > 1 && (
                        <button
                          type="button"
                          onClick={() => removePort(index)}
                          className="px-3 py-2 text-red-600 hover:text-red-700"
                        >
                          <XMarkIcon className="h-5 w-5" />
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              {/* Environment Variables */}
              <div>
                <div className="flex justify-between items-center mb-4">
                  <label className="block text-sm font-medium text-gray-700">Environment Variables</label>
                  <button
                    type="button"
                    onClick={addEnvironment}
                    className="text-sm text-[#90c740] hover:text-[#7ebd2e] font-medium"
                  >
                    + Add Environment Variable
                  </button>
                </div>
                <div className="space-y-3">
                  {formData.environment.map((env, index) => (
                    <div key={index} className="flex gap-3 items-end">
                      <div className="flex-1">
                        <label className="block text-xs font-medium text-gray-600 mb-1">Key</label>
                        <input
                          type="text"
                          value={env.key}
                          onChange={(e) => handleEnvChange(index, "key", e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#90c740] focus:border-[#90c740]"
                          placeholder="e.g., UI_URL_PORT"
                        />
                      </div>
                      <div className="flex-1">
                        <label className="block text-xs font-medium text-gray-600 mb-1">Value</label>
                        <input
                          type="text"
                          value={env.value}
                          onChange={(e) => handleEnvChange(index, "value", e.target.value)}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#90c740] focus:border-[#90c740]"
                          placeholder="e.g., 3000"
                        />
                      </div>
                      <div className="flex items-center gap-2">
                        <label className="flex items-center gap-2 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={env.isSecret}
                            onChange={(e) => handleEnvChange(index, "isSecret", e.target.checked)}
                            className="rounded border-gray-300 text-[#90c740] focus:ring-[#90c740]"
                          />
                          <span className="text-xs text-gray-600">Secret</span>
                        </label>
                      </div>
                      {formData.environment.length > 1 && (
                        <button
                          type="button"
                          onClick={() => removeEnvironment(index)}
                          className="px-3 py-2 text-red-600 hover:text-red-700"
                        >
                          <XMarkIcon className="h-5 w-5" />
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="flex-none flex justify-end gap-4 p-6 border-t border-gray-200 bg-gray-50">
            <button
              onClick={onClose}
              disabled={isSubmitting}
              className="px-6 py-3 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={isSubmitting || !formData.name || !formData.imageFull}
              className="px-6 py-3 bg-[#90c740] text-white rounded-lg hover:bg-[#7ebd2e] transition-colors duration-200 font-medium shadow-sm disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isSubmitting ? (
                <>
                  <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Saving...
                </>
              ) : (
                mode === 'add' ? 'Add Image' : 'Save Changes'
              )}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="px-6 py-4">
          <h1 className="text-2xl font-bold text-gray-900">Customer Details</h1>
          <p className="text-gray-600 mt-1">View and manage customer information</p>
        </div>
      </div>

      {/* Tab Menu */}
      <div className="bg-white border-b border-gray-200">
      <TabMenu />
      </div>

      {/* Main Content */}
      <div className="p-6">
        <div className="flex flex-col lg:flex-row gap-6">
        {/* Left Section (Editable Tables) */}
          <div className="w-full lg:w-3/5 space-y-6">
            {tableSections.map((section, index) => {
              const hasData = section.data && section.data.length > 0;
              const isEmpty = !hasData;
              
              return (
                <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200">
                  <div className="p-6 border-b border-gray-100">
                    <div className="flex justify-between items-center">
                      <h2 className="text-lg font-semibold text-gray-900">{section.title}</h2>
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => {
                            const config = getAddModalConfig(section.title);
                            if (config) {
                              setAddModalData({ ...config, sectionTitle: section.title });
                            }
                          }}
                          className="inline-flex items-center gap-2 px-4 py-2 text-sm bg-[#90c740] text-white rounded-lg hover:bg-[#7ebd2e] transition-colors duration-200 font-medium shadow-sm"
                        >
                          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                          </svg>
                          Add
                        </button>
                <button
                  onClick={() => setModalData(section)}
                          disabled={isEmpty}
                          className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 font-medium ${
                            isEmpty
                              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                              : 'bg-gray-600 text-white hover:bg-gray-700'
                          }`}
                >
                  Edit
                </button>
              </div>
                    </div>
                  </div>
                  <div className="p-6">
                    {section.title !== "Company Details" ? (
                      <DynamicTable
                columns={customerColumns}
                data={section.data}
                      />
                    ) : (
                <DynamicTable
                        columns={companyDetailsColumns}
                data={section.data}
                />
                    )}
            </div>
                </div>
              );
            })}
        </div>

          {/* Right Section (Authorized Personnel) */}
          <div className="w-full lg:w-2/5">
            <div className="bg-white rounded-xl shadow-sm border border-gray-200">
              <div className="p-6 border-b border-gray-100">
                <div className="flex justify-between items-center">
                  <div>
                    <h2 className="text-lg font-semibold text-gray-900">Authorized Personnel</h2>
                    <p className="text-sm text-gray-600 mt-1">All authorized contacts for this customer</p>
        </div>
                  <div className="flex items-center gap-2">
                <button
                  onClick={() => {
                        setAddModalData({
                          title: "Add Authorized Personnel",
                          sectionTitle: "Authorized Personnel",
                          fields: [
                            { key: "Name", label: "Name", type: "text", required: true },
                            { key: "Surname", label: "Surname", type: "text", required: true },
                            { key: "email", label: "Email", type: "text", required: true },
                            { key: "MobileNumber", label: "Mobile Number", type: "text" },
                            { 
                              key: "AccessRight", 
                              label: "Access Right", 
                              type: "list",
                              data: [
                                { id: "SuperUser", name: "SuperUser" },
                                { id: "Administrator", name: "Administrator" },
                                { id: "Technical", name: "Technical" }
                              ],
                              required: true 
                            }
                          ]
                        });
                      }}
                      className="inline-flex items-center gap-2 px-4 py-2 text-sm bg-[#90c740] text-white rounded-lg hover:bg-[#7ebd2e] transition-colors duration-200 font-medium shadow-sm"
                    >
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                      </svg>
                  Add
                </button>
                    <button
                      onClick={() => setModalData({ title: "Authorized Personnel", data: allContacts })}
                      disabled={!allContacts || allContacts.length === 0}
                      className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 font-medium ${
                        !allContacts || allContacts.length === 0
                          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                          : 'bg-gray-600 text-white hover:bg-gray-700'
                      }`}
                    >
                      Edit
                </button>
              </div>
                </div>
              </div>
              <div className="p-6">
              <DynamicTable
                  columns={allContactsColumns} 
                  data={allContacts} 
              />
              </div>
            </div>
            </div>
    </div>
      
        {/* Docker Images Section */}
        <div className="mt-6">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200">
            <div className="p-6 border-b border-gray-100">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-lg font-semibold text-gray-900">Docker Images / Server Information</h2>
                  <p className="text-sm text-gray-600 mt-1">Manage Docker images running on customer's network</p>
                </div>
                <button
                  onClick={() => {
                    setDockerImageModal({ mode: 'add', image: null, index: null });
                  }}
                  className="inline-flex items-center gap-2 px-4 py-2 text-sm bg-[#90c740] text-white rounded-lg hover:bg-[#7ebd2e] transition-colors duration-200 font-medium shadow-sm"
                >
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                  Add Image
                </button>
              </div>
            </div>
            <div className="p-6">
              {/* PEM File Management */}
              <div className="mb-8 border border-dashed border-gray-300 rounded-lg p-4 bg-gray-50">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                  <div>
                    <h3 className="text-md font-semibold text-gray-900">Server PEM File</h3>
                    <p className="text-sm text-gray-600 mt-1">
                      Upload and manage the PEM file associated with this customer&apos;s server.
                    </p>
                    {serverDetails ? (
                      <p className="text-xs text-gray-500 mt-1">
                        Server record ID: <span className="font-mono">{serverDetails.id}</span>
                      </p>
                    ) : (
                      <p className="text-xs text-red-500 mt-1">
                        No server details record found for this customer. PEM file cannot be managed.
                      </p>
                    )}
                  </div>
                  <div className="flex flex-wrap items-center gap-2">
                    <input
                      type="file"
                      accept=".pem"
                      ref={pemInputRef}
                      className="hidden"
                      onChange={(e) => {
                        const file = e.target.files && e.target.files[0];
                        if (file) {
                          handleUploadPemFile(file);
                        }
                        // reset input so same file can be selected again
                        e.target.value = "";
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => pemInputRef.current && pemInputRef.current.click()}
                      disabled={isPemUpdating || !serverDetails}
                      className="inline-flex items-center gap-2 px-4 py-2 text-sm bg-[#90c740] text-white rounded-lg hover:bg-[#7ebd2e] transition-colors duration-200 font-medium shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isPemUpdating ? (
                        <>
                          <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          Saving...
                        </>
                      ) : (
                        <>
                          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                          </svg>
                          {getPemFileName() ? "Replace PEM File" : "Upload PEM File"}
                        </>
                      )}
                    </button>
                    {getPemFileUrl() && (
                      <>
                        <button
                          type="button"
                          onClick={() => {
                            const url = getPemFileUrl();
                            if (!url) return;
                            const link = document.createElement("a");
                            link.href = url;
                            link.download = getPemFileName() || "server.pem";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }}
                          className="inline-flex items-center gap-2 px-4 py-2 text-sm bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors duration-200 font-medium shadow-sm"
                        >
                          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v16h16V4M8 10l4 4 4-4" />
                          </svg>
                          Download PEM
                        </button>
                        <button
                          type="button"
                          onClick={handleDeletePemFile}
                          disabled={isPemUpdating}
                          className="inline-flex items-center gap-2 px-4 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200 font-medium shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                          Remove PEM
                        </button>
                      </>
                    )}
                  </div>
                </div>
                {getPemFileName() && (
                  <p className="mt-3 text-sm text-gray-700">
                    Current file: <span className="font-mono">{getPemFileName()}</span>
                  </p>
                )}
                {!getPemFileName() && serverDetails && (
                  <p className="mt-3 text-sm text-gray-500">
                    No PEM file uploaded yet for this server.
                  </p>
                )}
              </div>

              {dockerImages.length === 0 ? (
                <div className="text-center py-12">
                  <div className="text-gray-400 mb-4">
                    <svg className="mx-auto h-16 w-16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                    </svg>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">No Docker Images</h3>
                  <p className="text-gray-500 mb-6">Get started by adding a Docker image configuration.</p>
                </div>
              ) : (
                <div className="space-y-4">
                  {dockerImages.map((image, index) => (
                    <div key={index} className="border border-gray-200 rounded-lg p-6 bg-gray-50 hover:bg-gray-100 transition-colors">
                      <div className="flex justify-between items-start mb-4">
                        <div>
                          <h3 className="text-lg font-semibold text-gray-900 mb-2">{image.name || `Image ${index + 1}`}</h3>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                            <div>
                              <span className="font-medium text-gray-700">Image Full:</span>
                              <p className="text-gray-600 mt-1">{image.imageFull || "-"}</p>
                            </div>
                            <div>
                              <span className="font-medium text-gray-700">Repository:</span>
                              <p className="text-gray-600 mt-1">{image.imageRepository || "-"}</p>
                            </div>
                            <div>
                              <span className="font-medium text-gray-700">Tag:</span>
                              <p className="text-gray-600 mt-1">{image.imageTag || "-"}</p>
                            </div>
                            {image.subDomain && (
                              <div>
                                <span className="font-medium text-gray-700">Subdomain:</span>
                                <p className="text-gray-600 mt-1">{image.subDomain}</p>
                              </div>
                            )}
                            {image.ports && image.ports.length > 0 && (
                              <div>
                                <span className="font-medium text-gray-700">Ports:</span>
                                <div className="mt-1 space-y-1">
                                  {image.ports.map((port, pIndex) => (
                                    <p key={pIndex} className="text-gray-600">
                                      {port.hostPort}:{port.containerPort} ({port.protocol || "tcp"})
                                    </p>
                                  ))}
                                </div>
                              </div>
                            )}
                            {image.environment && image.environment.length > 0 && (
                              <div className="md:col-span-2">
                                <span className="font-medium text-gray-700">Environment Variables:</span>
                                <div className="mt-1 space-y-1">
                                  {image.environment.map((env, eIndex) => (
                                    <p key={eIndex} className="text-gray-600">
                                      <span className="font-medium">{env.key}:</span> {env.isSecret ? "***" : env.value}
                                    </p>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => {
                              setDockerImageModal({ mode: 'edit', image: image, index: index });
                            }}
                            className="px-3 py-2 text-sm bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors duration-200 font-medium"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDeleteDockerImage(index)}
                            className="px-3 py-2 text-sm bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors duration-200 font-medium"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      
        {/* Communication Section */}
        <div className="mt-6">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200">
            <div className="p-6 border-b border-gray-100">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <div className="flex items-center gap-4">
                  <div>
                    <h2 className="text-xl font-bold text-gray-900">Support Tickets</h2>
                    <p className="text-sm text-gray-600 mt-1">View and manage support tickets</p>
                  </div>
                  <div className="flex items-center gap-2 px-4 py-2 bg-[#90c740]/10 rounded-lg">
                    <span className="text-sm font-medium text-[#90c740]">Total: {tickets.length}</span>
                  </div>
                </div>
                <button
                  onClick={() => setAddTicketModal(addTicketData)}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-[#90c740] text-white rounded-lg hover:bg-[#7ebd2e] transition-colors duration-200 font-medium shadow-sm"
                >
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                  New Ticket
                </button>
              </div>
            </div>
            <div className="p-6">
              {renderTicketList()}
            </div>
          </div>
        </div>
      </div>

      {/* Ticket Details Modal */}
      {isTicketModalOpen && selectedTicket && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={closeTicketModal}>
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col" onClick={(e) => e.stopPropagation()}>
            <div className="flex-none flex justify-between items-center p-6 border-b border-gray-200">
              <h2 className="text-xl font-bold text-gray-900">Ticket Details</h2>
              <button
                onClick={closeTicketModal}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>
            <div className="flex-1 p-6 overflow-y-auto min-h-0">
              {renderTicketModalContent()}
            </div>
          </div>
        </div>
      )}

      {/* Image Viewer Modal */}
      {isImageViewerOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50" onClick={closeImageViewer}>
          <div className="relative max-w-5xl w-full px-4" onClick={(e) => e.stopPropagation()}>
            <button
              className="absolute -top-12 right-0 text-white text-2xl hover:text-gray-300 transition-colors"
              onClick={closeImageViewer}
            >
              ✕
            </button>
            <div className="bg-black rounded-xl overflow-hidden flex items-center justify-center shadow-2xl">
              {viewerImages.length > 0 && (
                <img 
                  src={viewerImages[viewerIndex]} 
                  alt={`Attachment ${viewerIndex + 1}`} 
                  className="max-h-[80vh] max-w-full object-contain" 
                />
              )}
            </div>
            {viewerImages.length > 1 && (
              <div className="flex items-center justify-between mt-6">
                <button 
                  onClick={prevImage} 
                  className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-lg hover:bg-gray-100 transition-colors font-medium"
                >
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                  Previous
                </button>
                <span className="text-white text-sm font-medium bg-black/50 px-4 py-2 rounded-lg">
                  {viewerIndex + 1} / {viewerImages.length}
                </span>
                <button 
                  onClick={nextImage} 
                  className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-lg hover:bg-gray-100 transition-colors font-medium"
                >
                  Next
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      
      {modalData && (
        <EditModal 
          section={modalData} 
          onClose={() => setModalData(null)}
      onSave={handleSaveModalData}
        />
      )}

        {addTicketModal && (
          <AddModal
            title={`Add ${addTicketModal.title}`}
            fields={addTicketModal.fields}
            onSave={(newData) => handleSaveNewData(newData)}
            onClose={() => setAddTicketModal(null)}
          />
        )}

      {addModalData && (
        <AddModal
          title={addModalData.title}
          fields={addModalData.fields}
          onSave={(newData) => handleAddNewData(newData)}
          onClose={() => setAddModalData(null)}
          enableExistingSelection={true}
          existingData={availableContacts}
        />
      )}

      {/* Docker Image Modal */}
      {dockerImageModal && (
        <DockerImageModal
          mode={dockerImageModal.mode}
          image={dockerImageModal.image}
          index={dockerImageModal.index}
          onSave={(imageData) => {
            if (dockerImageModal.mode === 'add') {
              handleAddDockerImage(imageData);
            } else {
              handleEditDockerImage(dockerImageModal.index, imageData);
            }
            setDockerImageModal(null);
          }}
          onClose={() => setDockerImageModal(null)}
        />
      )}

      <Toaster position="top-right" />
    </div>
  );
};

export default DetailsPage;
